import ListTableColumnTag from '@components/list-table-column-tag'
import ListTableCustomAction from './list-table-custom-action.vue'

// 表格的配置
const tableConfig = {
  name: 'CourseList',
  mode: 'table',
  list: {
    type: 'Table',
    columns: [
      {
        prop: 'name',
        label: '课程名称',
        showOverflowTooltip: true,
        minWidth: '200'
      },
      {
        prop: 'tags',
        label: '标签',
        // 自定义组件
        component: ListTableColumnTag,
        minWidth: '200'
      },

      {
        prop: 'courseWaresAmount',
        label: '课件数',
        minWidth: '100'
      },
      {
        prop: 'action',
        label: '操作',
        width: '160',
        fixed: 'right',
        // 自定义组件
        component: ListTableCustomAction,
        actionMap: [
          {
            text: '统计分析',
            componentsName: 'button',
            componentsConfig: {
            },
            eventName: 'on-statistics-click'

          },
          {
            text: '详情',
            componentsName: 'button',
            componentsConfig: {
            },
            eventName: 'on-detail-click'
          }
        ]
      }
    ]
  }

}

export default tableConfig
